<template>
  <div class="works">
    <div class="header">
      <div class="header-left">
        <div class="title-container">
          <div class="title-line"></div>
          <h2>作品管理</h2>
        </div>
        <div class="category-filter">
          <div style="margin-right: 10px;">选择分类:</div>
          <el-select v-model="selectedCategory" placeholder="请选择分类" style="width: 200px" @change="fetchWorksData">
            <el-option v-for="category in categories" :key="category.id" :label="category.name"
              :value="category.id === 0 ? '' : category.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="actions">
        <el-button type="primary" @click="RefreshData">刷新数据</el-button>
        <el-button type="primary" @click="showAddDialog">添加作品</el-button>
        <el-button type="primary" @click="deleteSelected">删除作品</el-button>
        <el-button type="primary" @click="clearAll">清空作品</el-button>

      </div>
    </div>

    <div class="works-container">

      <div v-if="list.length > 0" class="works-section">
        <div class="works-list">
          <div v-for="(work, index) in list" :key="index" class="work-card-horizontal">
            <el-checkbox v-model="selectedWorks" :label="`${index}`" class="work-checkbox"></el-checkbox>
            <div class="work-content">
              <div class="work-image-container" @click="previewWorkImage(work.cover_image)">
                <img :src="work.cover_image" class="work-image-fixed" style="cursor: pointer;" />
              </div>
              <div class="work-details">
                <div class="work-header">
                  <el-tag type="primary" size="small">{{ work.category_name }}</el-tag>
                     <el-tag :type="getStatusType(work.status)" size="small">{{ getStatusText(work.status) }}</el-tag>
                     <el-tag type="primary" size="small">{{ work.mode }}</el-tag>
                  
               
                </div>
                <h3 class="work-title">{{ work.title }}</h3>
                <p class="work-description" v-if="work.description">{{ work.description }}</p>
                <div class="work-stats-grid">
                  <div class="stat-item">
                    <span class="stat-label">浏览量:</span>
                    <span class="stat-value">{{ work.views || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">点赞量:</span>
                    <span class="stat-value">{{ work.likes || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">今日收益:</span>
                    <span class="stat-value">¥{{ work.todayRevenue || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">昨日收益:</span>
                    <span class="stat-value">¥{{ work.yesterdayRevenue || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">连载状态:</span>
                    <span class="stat-value">{{ getSerialText(work.isSerial) }}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">创建时间:</span>
                    <span class="stat-value">{{ work.create_time || '未知' }}</span>
                  </div>
                </div>
              </div>
              <div style="width: 120px;">
                <el-dropdown @command="handleCommand">
                  <el-button type="primary">
                    操作<el-icon class="el-icon--right"><arrow-down /></el-icon>
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item :command="{ action: 'edit', work }">修改</el-dropdown-item>
                      <el-dropdown-item :command="{ action: 'delete', work }">删除</el-dropdown-item>
                      <el-dropdown-item :command="{ action: 'viewEpisodes', work }">查看选集</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>

              </div>
            </div>
          </div>
        </div>
        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- Add Work Dialog -->
    <div v-if="showDialog" class="dialog-overlay">
      <div class="dialog">
        <h3 class="dialog-title">{{ this.isEditMode == true ? '修改作品' : '添加作品' }}</h3>
        <el-form label-width="120px">
             <div class="upload-tip">
              <span class="tip-text">📌 封面尺寸要求：</span>
              <span class="tip-item">横屏封面 ≤ 1920×1080</span>
              <span class="tip-item">竖屏封面 ≤ 1080×1920</span>
            </div>
          <el-form-item label="作品封面">
         
            <el-upload action="#" :auto-upload="false" :show-file-list="false" :on-change="handleImageUpload"
              accept="image/*">
              <template #trigger>
                <el-button v-if="!newWork.image" type="primary">点击上传</el-button>
              </template>
              <div v-if="newWork.image" class="image-preview-container">
                <div class="image-wrapper">
                  <img :src="newWork.image" class="image-preview" alt="Preview">
                  <div class="image-actions">
                    <el-button circle icon="View" @click.stop="previewImage" class="action-btn"></el-button>
                    <el-button circle icon="Delete" @click.stop="removeImage" class="action-btn"></el-button>
                  </div>
                </div>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item label="作品标题">
            <el-input v-model="newWork.name" placeholder="请输入作品标题"></el-input>
          </el-form-item>

          <el-form-item label="作品描述">
            <el-input v-model="newWork.description" type="textarea" :rows="3" placeholder="请输入作品描述"></el-input>
          </el-form-item>


          <el-form-item label="作品类型">
            <el-select v-model="newWork.type" style="width:100%" placeholder="请选择作品类型">
              <el-option v-for="category in categories.filter(cat => cat.id !== 0)" :key="category.id"
                :label="category.name" :value="category.name">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="作品模式">
            <el-select v-model="newWork.mode" style="width:100%">
              <el-option label="沙雕动画" value="沙雕动画"></el-option>
              <el-option label="解压视频" value="解压视频"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="连载状态">
            <el-select v-model="newWork.isSerial" style="width:100%">
              <el-option label="连载中" :value="0"></el-option>
              <el-option label="已完结" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dialog-actions">
            <el-button type="primary" @click="addWork">确认</el-button>
            <el-button @click="closeDialog">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { ArrowDown, Plus, Delete, Refresh } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import Compressor from 'compressorjs'

export default {
  name: 'WorksView',

  data() {
    return {
      showDialog: false,
      isEditMode: false,
      newWork: {
        image: '',
        name: '',
        description: '',
        isSerial: 0,
        type: '',
        mode: '沙雕动画',
        views: 0,
        revenue: 0,
        status: 1
      },
      list: [],
      selectedWorks: [],
      categories: [],
      selectedCategory: '全部',
      currentPage: 1,
      pageSize: 10,
      total: 0,
    }
  },
  components: {
    ArrowDown,
    Plus,
    Delete,
    Refresh
  },
  created() {
    this.fetchCategories()
    this.fetchWorksData()
  },

  methods: {
    handleCommand(command) {
      let self = this
      const { action, work } = command
      switch (action) {
        case 'edit':
          console.log('调用editWork')
          this.editWork(work)
          break
        case 'delete':
          self.deleteWork(work)
          break
        case 'viewEpisodes':
          self.viewEpisodes(work)
          break
        default:
          console.warn('未知操作:', action)
      }
    },
    fetchCategories() {
      this.$axios.get('api/Bloger/getwordcategories', {
        headers: {
          'token': localStorage.getItem('token') || ''
        }
      }).then(response => {
        if (response.data && response.code == 1) {
          this.categories = response.data
          // 在最前面添加"全部"选项
          this.categories.unshift({ id: 0, name: '全部' })
        } else {
          ElMessage.error('获取分类失败: ' + (response.message || '未知错误'))
        }
      }).catch(error => {
        console.error('获取分类失败:', error)
        ElMessage.error('获取分类失败: ' + error.message)
      })
    },
    RefreshData() {
      this.fetchWorksData()
    },
    fetchWorksData() {
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize
      }
      // 如果不是"全部"选项，则添加分类参数
      if (this.selectedCategory) {
        params.mode = this.selectedCategory
      }
      this.$axios.get('api/Bloger/getWorks', {
        params,
        headers: {
          'token': localStorage.getItem('token') || ''
        }
      }).then(response => {
        if (response.data && response.code == 1) {
          this.list = response.data || []
          this.total = response.meta.total_count || 0
          ElMessage.success(response.msg || '获取作品数据成功')
        } else {
          ElMessage.error('获取作品数据失败: ' + (response.message || '未知错误'))
        }
      }).catch(error => {
        console.error('获取作品数据失败:', error)
        ElMessage.error('获取作品数据失败: ' + error.message)
      })
    },
    showAddDialog() {
      this.isEditMode = false
      this.showDialog = true
    },
    closeDialog() {
      this.showDialog = false
      this.resetNewWork()
    },
    resetNewWork() {
      this.newWork = {
        image: '',
        name: '',
        description: '',
        isSerial: 0,
        type: '',
        mode: '沙雕动画',
        views: 0,
        revenue: 0
      }
    },
    async handleImageUpload(file) {
      try {
        // 压缩图片
        new Compressor(file.raw, {
          quality: 0.7,
          maxWidth: 1600,
          maxHeight: 1600,
          convertSize: 5000000, // 5MB以上图片自动转换为jpeg
          mimeType: 'image/jpeg', // 强制使用jpeg格式
          success: async (compressedFile) => {
            try {
              const formData = new FormData()
              // 确保文件名有正确的扩展名
              const fileName = file.name ?
                file.name.replace(/\.[^/.]+$/, '.jpg') :
                `image_${Date.now()}.jpg`
              // 创建新的Blob对象确保正确格式
              const finalFile = new File([compressedFile], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })
              formData.append('file', finalFile)

              const response = await this.$axios.post('api/Bloger/upload', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'token': localStorage.getItem('token') || ''
                },
                timeout: 30000 // 30秒超时
              })

              if (response.data && response.code == 1) {
                this.newWork.image = response.data.url
                ElMessage.success('图片上传成功')
              } else {
                ElMessage.error('图片上传失败: ' + (response.message || '未知错误'))
              }
            } catch (uploadError) {
              console.error('上传失败:', uploadError)
              let errorMsg = '图片上传失败'
              if (uploadError.response?.status === 413) {
                errorMsg = '图片太大，请尝试更小的图片'
              } else if (uploadError.code === 'ECONNABORTED') {
                errorMsg = '上传超时，请重试'
              }
              ElMessage.error(errorMsg)
            }
          },
          error: (err) => {
            console.error('图片压缩失败:', err)
            let errorMsg = '图片压缩失败'
            if (err.message.includes('size')) {
              errorMsg = '图片太大，请选择小于10MB的图片'
            }
            ElMessage.error(errorMsg)
          }
        })
      } catch (error) {
        console.error('处理图片失败:', error)
        ElMessage.error('处理图片失败: ' + error.message)
      }
    },
    previewImage() {
      this.$confirm('', '图片预览', {
        showCancelButton: false,
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: 'image-preview-modal',
        message: `
          <div style="text-align:center">
            <img src="${this.newWork.image}" style="max-width:100%; max-height:80vh; display:inline-block">
          </div>
        `,
        dangerouslyUseHTMLString: true
      }).catch(() => { })
    },
    removeImage() {
      this.newWork.image = ''
    },
    addWork() {
      // 检查必填字段
      if (!this.newWork.image) {
        ElMessage.error('请上传作品封面')
        return
      }
      if (!this.newWork.name) {
        ElMessage.error('请输入作品标题')
        return
      }
      if (!this.newWork.type) {
        ElMessage.error('请选择作品类型')
        return
      }

      const work = { ...this.newWork }
      let url = 'api/Bloger/addWorks'

      if (this.isEditMode) {
        url = 'api/Bloger/updateWorks'
        // 确保在修改模式下发送ID
        work.id = this.newWork.id
      }

      this.$axios.post(url, work, {
        headers: {
          'token': localStorage.getItem('token') || '',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.code == 1) {
          ElMessage.success(this.isEditMode ? '作品修改成功' : '作品添加成功')
          this.fetchWorksData() // 刷新作品列表
          this.resetNewWork()
          this.closeDialog()
        } else {
          ElMessage.error((this.isEditMode ? '作品修改失败' : '作品添加失败') + ': ' + (response.message || '未知错误'))
        }
      }).catch(error => {
        console.error('操作失败:', error)
        ElMessage.error((this.isEditMode ? '作品修改失败' : '作品添加失败') + ': ' + error.message)
      })
    },

    deleteSelected() {
      if (this.selectedWorks.length === 0) {
        ElMessage.warning('请先选择要删除的作品')
        return
      }

      this.$confirm('确定要删除选中的作品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.selectedWorks.map(index => this.list[index].id)
        this.$axios.post('api/Bloger/deleteWorks', { ids }, {
          headers: {
            'token': localStorage.getItem('token') || '',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (response.code == 1) {
            ElMessage.success('删除成功')
            this.fetchWorksData()
            this.selectedWorks = []
          } else {
            ElMessage.error('删除失败: ' + (response.message || '未知错误'))
          }
        }).catch(error => {
          console.error('删除失败:', error)
          ElMessage.error('删除失败: ' + error.message)
        })
      }).catch(() => { })
    },
    clearAll() {
      this.list = []
      this.$axios.post('api/Bloger/clearWorks', {}, {
        headers: {
          'token': localStorage.getItem('token') || '',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.code == 1) {
          ElMessage.success('清空成功')
          this.fetchWorksData()
        } else {
          ElMessage.error('清空失败: ' + (response.message || '未知错误'))
        }
      })
    },
    editWork(work) {
      this.isEditMode = true
      this.newWork = {
        image: work.cover_image || '',
        name: work.title || '',
        description: work.description || '',
        isSerial: work.isSerial || 0,
        type: work.category_name || '',
        mode: work.mode || '沙雕动画',
        id: work.id // 添加ID用于更新操作
      }
      this.showDialog = true
    },
    deleteWork(work) {
      this.$confirm('确定要删除这个作品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 发送删除请求到后端
        this.$axios.post('api/Bloger/deleteWorks', { ids: [work.id] }, {
          headers: {
            'token': localStorage.getItem('token') || '',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (response.code == 1) {
            ElMessage.success('删除成功')
            this.fetchWorksData() // 刷新作品列表
          } else {
            ElMessage.error('删除失败: ' + (response.message || '未知错误'))
          }
        }).catch(error => {
          console.error('删除失败:', error)
          ElMessage.error('删除失败: ' + error.message)
        })
      }).catch(() => { })
    },
    viewEpisodes(work) {
      this.$router.push({
        path: '/episodes',
        query: { workId: work.id }
      })
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchWorksData()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.fetchWorksData()
    },
    getStatusText(status) {
      switch (status) {
        case '0':
          return '待审核'
        case '1':
          return '已审核'
        case '2':
          return '已下架'
        default:
          return '未知状态'
      }
    },
    getStatusType(status) {
      switch (status) {
        case 0:
          return 'warning' // 待审核 - 黄色
        case 1:
          return 'success' // 已审核 - 绿色
        case 2:
          return 'danger'  // 已下架 - 红色
        default:
          return 'info'    // 未知状态 - 蓝色
      }
    },
    getSerialText(isSerial) {
      return isSerial === 1 ? '已完结' : '连载中'
    },
    // 预览作品封面图片
    previewWorkImage(imageUrl) {
      if (!imageUrl) {
        this.$message.warning('该作品没有封面图片')
        return
      }
      
      this.$confirm('', '封面图片预览', {
        showCancelButton: false,
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: 'image-preview-modal',
        message: `
          <div style="text-align:center">
            <img src="${imageUrl}" style="max-width:100%; max-height:80vh; display:inline-block">
          </div>
        `,
        dangerouslyUseHTMLString: true
      }).catch(() => { })
    }

  },

}
</script>

<style scoped>
/* 上传提示样式 */
.upload-tip {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 12px;
  font-size: 12px;
}

.tip-text {
  color: #ff4d4f;
  font-weight: 600;
  margin-right: 8px;
}

.tip-item {
  color: #ff4d4f;
  background: #fff1f0;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 8px;
  border: 1px solid #ffa39e;
}

.tip-item:last-child {
  margin-right: 0;
}

/* 原始样式保持不变 */
.works {
  padding: 24px;
  background-color: #f5f7fa;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 24px;
}

.title-container {
  display: flex;
  align-items: center;
}

.title-line {
  width: 4px;
  height: 24px;
  background: linear-gradient(to bottom, #1890ff, #52c41a);
  margin-right: 12px;
  border-radius: 2px;
}

h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.actions .el-button {
  min-width: 80px;
  text-align: center;
}

.action-btn {
  padding: 8px 16px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 80px;
  text-align: center;
}

.action-btn:hover {
  background: #40a9ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

.works-section {
  margin-bottom: 32px;
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  color: #333;
}

.section-title .title-line {
  width: 3px;
  height: 18px;
  margin-right: 10px;
}

.works-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.work-card {
  position: relative;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s;
}

.work-card.horizontal {
  border-left: 4px solid #1890ff;
}

.work-card.vertical {
  border-left: 4px solid #52c41a;
}

.work-checkbox {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}

.work-checkbox ::v-deep .el-checkbox__label {
  display: none;
}

.work-checkbox ::v-deep .el-checkbox__input {
  margin-right: 0;
}

.work-card:hover {
  transform: translateY(-4px);
}

.work-image {
  width: 100%;
  height: 180px;
  object-fit: contain;
  border-bottom: 1px solid #f0f0f0;
}

.work-card.vertical .work-image {
  height: 300px;
  object-position: top;
}

.work-info {
  padding: 16px;
}

.work-info {
  padding: 12px;
}

.work-name {
  font-weight: bold;
  margin-bottom: 3px;
  color: #333;
  font-size: 15px;
}

.work-stats p {
  margin: 6px 0;
  color: #666;
  font-size: 13px;
}

.work-actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog {
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 480px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.dialog-title {
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 18px;
  color: #333;
  text-align: center;
}

.image-preview-container {
  margin-top: 10px;
  position: relative;
}

.image-wrapper {
  position: relative;
  width: 150px;
  height: 150px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #eee;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.image-wrapper:hover .image-actions {
  opacity: 1;
}

.dialog-actions {
  margin-top: 20px;
  text-align: right;
}

.stats-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.pagination-container {
  margin-top: 10px;
}

.category-filter {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.works-container {
  background-color: #fff;
  padding: 10px;
}

/* 横向卡片布局样式 */
.works-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.work-card-horizontal {
  position: relative;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s;
  border: 1px solid #e8e8e8;
}

.work-card-horizontal:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.work-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.work-image-container {
  flex-shrink: 0;
  width: 120px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.work-image-fixed {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.work-details {
  flex: 1;
  min-width: 0;
}

.work-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.work-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.work-description {
  margin: 0 0 12px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.work-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px 16px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-label {
  font-size: 12px;
  color: #999;
}

.stat-value {
  font-size: 12px;
  color: #333;
  font-weight: 500;
}

.work-actions {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: auto;
}

.work-actions .el-button {
  min-width: 80px;
  text-align: center;
}

.work-checkbox {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}

.work-checkbox ::v-deep .el-checkbox__label {
  display: none;
}

.work-checkbox ::v-deep .el-checkbox__input {
  margin-right: 0;
}
</style>
